/* ==========================================================================
   List Product — Swiper carousel
   ========================================================================== */

/** Inisialisasi Swiper marquee di section list-product */
function initListProductSwipers() {
  if (!window.Swiper) return;

  document.querySelectorAll('.list-product__swiper').forEach((el) => {
    if (el.swiper) el.swiper.destroy(true, true);

    const slides = el.querySelectorAll('.swiper-slide').length;
    if (slides < 2) return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: 3000,
      allowTouchMove: true,
      grabCursor: true,
      freeMode: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      breakpoints: {
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 64,
          speed: 5000,
        },
      },
    });
  });
}

window.addEventListener('load', initListProductSwipers);
document.addEventListener('shopify:section:load', initListProductSwipers);

/* ==========================================================================
   Register popup — drawer kanan
   ========================================================================== */

/** Durasi animasi slide drawer (ms), harus selaras dengan CSS transition */
const REGISTER_MODAL_MS = 350;

/** Salin email dari subscribe ke form register; kunci field jika sudah diisi */
function syncSubscribeEmailToRegister(trigger, modal) {
  const subscribeEmail = trigger
    ?.closest('.list-product-subscribe')
    ?.querySelector('[data-subscribe-email]');
  const registerEmail = modal?.querySelector('[data-register-email]');
  if (!registerEmail) return;

  const email = subscribeEmail?.value.trim() || '';
  registerEmail.value = email;

  if (email) {
    registerEmail.readOnly = true;
    registerEmail.setAttribute('aria-readonly', 'true');
    registerEmail.classList.add('is-locked');
  } else {
    registerEmail.readOnly = false;
    registerEmail.removeAttribute('aria-readonly');
    registerEmail.classList.remove('is-locked');
  }

  const form = registerEmail.closest('form');
  if (form) updateRegisterSubmitState(form);
}

/** Buka popup: tampilkan overlay + slide panel dari kanan */
function openRegisterModal(modal) {
  if (!modal) return;
  modal.removeAttribute('hidden');
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => modal.classList.add('is-active'));
  });
}

/** Tutup popup: slide keluar lalu sembunyikan setelah animasi selesai */
function closeRegisterModal(modal) {
  if (!modal) return;
  modal.classList.remove('is-active');
  window.setTimeout(() => {
    if (modal.classList.contains('is-active')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }, REGISTER_MODAL_MS);
}

/** Aktifkan tombol Submit hanya jika semua input sudah terisi */
function updateRegisterSubmitState(form) {
  const submit = form.querySelector('[data-register-submit]');
  if (!submit) return;

  const inputs = form.querySelectorAll('.list-product-register__input');
  const allFilled = Array.from(inputs).every((input) => input.value.trim() !== '');

  submit.disabled = !allFilled;
}

/** Pasang validasi form: cek isian + batasi phone hanya angka */
function initRegisterFormValidation(root = document) {
  root.querySelectorAll('.list-product-register__form').forEach((form) => {
    if (form.dataset.registerFormBound) return;
    form.dataset.registerFormBound = 'true';

    updateRegisterSubmitState(form);

    form.querySelectorAll('.list-product-register__input').forEach((input) => {
      input.addEventListener('input', () => updateRegisterSubmitState(form));
    });

    form.querySelectorAll('[data-register-phone]').forEach((input) => {
      input.addEventListener('input', () => {
        input.value = input.value.replace(/[^\d+\-\s()]/g, '');
        updateRegisterSubmitState(form);
      });

      input.addEventListener('keypress', (e) => {
        if (!/[\d+\-\s()]/.test(e.key)) e.preventDefault();
      });
    });
  });
}

/** Buka popup register kalau ada form.errors (reload dari return_to) */
function initRegisterOpenOnLoad(root = document) {
  root.querySelectorAll('.list-product-register[data-register-open-on-load="true"]').forEach((modal) => {
    openRegisterModal(modal);
  });
}

/** Inisialisasi tombol buka/tutup popup + validasi form register */
function initListProductRegister(root = document) {
  initRegisterFormValidation(root);
  initRegisterOpenOnLoad(root);

  root.querySelectorAll('[data-register-open]').forEach((btn) => {
    const modalId = btn.getAttribute('aria-controls');
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!modal || btn.dataset.registerBound) return;

    btn.dataset.registerBound = 'true';
    btn.addEventListener('click', () => {
      const subscribeEmail = btn
        .closest('.list-product-subscribe')
        ?.querySelector('[data-subscribe-email]');

      if (subscribeEmail && !subscribeEmail.checkValidity()) {
        subscribeEmail.reportValidity();
        return;
      }

      syncSubscribeEmailToRegister(btn, modal);
      openRegisterModal(modal);
    });
  });

  root.querySelectorAll('[data-register-close]').forEach((el) => {
    const modal = el.closest('.list-product-register');
    if (!modal || el.dataset.registerCloseBound) return;

    el.dataset.registerCloseBound = 'true';
    el.addEventListener('click', () => closeRegisterModal(modal));
  });
}

/** Tutup popup saat tekan Escape */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.list-product-register.is-open').forEach(closeRegisterModal);
});

window.addEventListener('load', () => initListProductRegister());
document.addEventListener('shopify:section:load', (e) => initListProductRegister(e.target));
